{
  "id": "tiktok.com",
  "version": 2,
  "name": "TikTok",
  "author": "SR",
  "date": "2023-06-23",
  "url": "https://www.tiktok.com",
  "strings": {
    "en": {
      "name": "TikTok",
      "help": [
        "https://support.tiktok.com/en/account-and-privacy/personalized-ads-and-data/requesting-your-data",
        "(Open the App and login with your account)",
        "Go to your Profile.",
        "Tap the 3-line icon in the top right to open your settings.",
        "Go to Privacy > Personalization and data > Download your Data",
        "Select 'JSON' as file format und click 'Request data'.",
        "You will receive a email to download the data export (in about 3-4 days)."
      ]
    },
    "de": {
      "name": "TikTok",
      "help": [
        "https://support.tiktok.com/de/account-and-privacy/personalized-ads-and-data/requesting-your-data",
        "(Öffne die App und melde dich an)",
        "Gehe zu deinem Profil ('Ich').",
        "Klicke auf die drei Striche oben rechts um deine Einstellungen zu öffnen.",
        "Gehe zu Datenschutz > Personalisierung und Daten > Deine Daten herunterladen",
        "Wähle JSON als Dateiformat aus und klicke auf Daten anfordern.",
        "Du erhälst eine Email zum Herunterladen deiner Informationen (in etwa 3-4 Tagen)"
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "Activity": [
                  {
                    "type": "object",
                    "properties": {
                      "Favorite Effects": [{ "type": "object", "properties": {} }],
                      "Favorite Hashtags": [
                        {
                          "type": "object",
                          "properties": {
                            "FavoriteHashtagList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "Link": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Favorite Sounds": [
                        {
                          "type": "object",
                          "properties": {
                            "FavoriteSoundList": [{ "type": "empty" }]
                          }
                        }
                      ],
                      "Favorite Videos": [
                        {
                          "type": "object",
                          "properties": {
                            "FavoriteVideoList": [{ "type": "empty" }]
                          }
                        }
                      ],
                      "Follower List": [
                        {
                          "type": "object",
                          "properties": {
                            "FansList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "UserName": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Following List": [
                        {
                          "type": "object",
                          "properties": {
                            "Following": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "UserName": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Hashtag": [
                        {
                          "type": "object",
                          "properties": {
                            "HashtagList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "HashtagName": [{ "type": "string" }],
                                      "HashtagLink": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Like List": [
                        {
                          "type": "object",
                          "properties": {
                            "ItemFavoriteList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "VideoLink": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Login History": [
                        {
                          "type": "object",
                          "properties": {
                            "LoginHistoryList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "pattern": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "IP": [{ "type": "string" }],
                                      "DeviceModel": [{ "type": "string" }],
                                      "DeviceSystem": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": { "iso": true }
                                          }
                                        }
                                      ],
                                      "NetworkType": [{ "type": "string" }],
                                      "Carrier": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Purchase History": [{ "type": "object", "properties": {} }],
                      "Search History": [
                        {
                          "type": "object",
                          "properties": {
                            "SearchList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "SearchTerm": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Share History": [
                        {
                          "type": "object",
                          "properties": {
                            "ShareHistoryList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "SharedContent": [{ "type": "string" }],
                                      "Link": [{ "type": "string" }],
                                      "Method": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ],
                      "Status": [
                        {
                          "type": "object",
                          "properties": {
                            "Resolution": [{ "type": "string" }],
                            "AppVersion": [{ "type": "string" }],
                            "Idfa": [{ "type": "string" }],
                            "GAid": [{ "type": "string" }],
                            "OpenUdid": [{ "type": "string" }],
                            "Clientudid": [{ "type": "string" }, { "type": "empty" }]
                          }
                        }
                      ],
                      "Video Browsing History": [
                        {
                          "type": "object",
                          "properties": {
                            "VideoList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "VideoLink": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                "Ads and data": [
                  {
                    "type": "object",
                    "properties": {
                      "Ad Interests": [
                        {
                          "type": "object",
                          "properties": {
                            "AdInterestCategories": [{ "type": "string" }, { "type": "empty" }]
                          }
                        }
                      ],
                      "Ads Based On Data Received From Partners": [
                        {
                          "type": "object",
                          "properties": {
                            "DataPartnerList": [{ "type": "string" }, { "type": "empty" }],
                            "AdvertiserList": [{ "type": "string" }]
                          }
                        }
                      ],
                      "Usage Data From Third-Party Apps And Websites": [{ "type": "object", "properties": {} }]
                    }
                  }
                ],
                "App Settings": [
                  {
                    "type": "object",
                    "properties": {
                      "Block": [{ "type": "object", "properties": {} }],
                      "Settings": [
                        {
                          "type": "object",
                          "properties": {
                            "SettingsMap": [
                              {
                                "type": "object",
                                "properties": {
                                  "Ads Based on Data Received from Partners": [{ "type": "string" }],
                                  "Allow DownLoad": [{ "type": "string" }],
                                  "Allow Others to Find Me": [{ "type": "string" }],
                                  "Filter Comments": [{ "type": "string" }],
                                  "Interests": [{ "type": "string" }],
                                  "Personalized Ads": [{ "type": "string" }],
                                  "Private Account": [{ "type": "string" }],
                                  "Video Languages Preferences": [{ "type": "string" }, { "type": "empty" }],
                                  "Who Can Duet With Me": [{ "type": "string" }],
                                  "Who Can Post Comments": [{ "type": "string" }],
                                  "Who Can React to Me": [{ "type": "string" }],
                                  "Who Can Send Me Message": [{ "type": "string" }],
                                  "Who Can View Videos I Liked": [{ "type": "string" }]
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                "Comment": [
                  {
                    "type": "object",
                    "properties": {
                      "Comments": [
                        {
                          "type": "object",
                          "properties": {
                            "CommentsList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "Comment": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                "Direct Messages": [
                  {
                    "type": "object",
                    "properties": {
                      "Chat History": [
                        {
                          "type": "object",
                          "properties": {
                            "ChatHistory": [
                              {
                                "type": "object",
                                "properties": {
                                  "Chat History with *": [
                                    {
                                      "type": "array",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "Date": [
                                              {
                                                "type": "string",
                                                "supposedUsage": {
                                                  "format": "time",
                                                  "argument": {
                                                    "format": "%Y-%m-%d %H:%M:%S"
                                                  }
                                                }
                                              }
                                            ],
                                            "From": [{ "type": "string" }],
                                            "Content": [{ "type": "string" }]
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                "Profile": [
                  {
                    "type": "object",
                    "properties": {
                      "Profile Information": [
                        {
                          "type": "object",
                          "properties": {
                            "ProfileMap": [
                              {
                                "type": "object",
                                "properties": {
                                  "bioDescription": [{ "type": "string" }],
                                  "birthDate": [{ "type": "string" }],
                                  "emailAddress": [{ "type": "string" }],
                                  "likesReceived": [{ "type": "string" }],
                                  "profilePhoto": [{ "type": "string" }],
                                  "profileVideo": [{ "type": "string" }],
                                  "telephoneNumber": [{ "type": "string" }],
                                  "userName": [{ "type": "string" }]
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ],
                "Video": [
                  {
                    "type": "object",
                    "properties": {
                      "Videos": [
                        {
                          "type": "object",
                          "properties": {
                            "VideoList": [
                              {
                                "type": "array",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "Date": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": {
                                              "format": "%Y-%m-%d %H:%M:%S"
                                            }
                                          }
                                        }
                                      ],
                                      "VideoLink": [{ "type": "string" }],
                                      "Likes": [{ "type": "string" }]
                                    }
                                  }
                                ]
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "Activity", "Login History", "LoginHistoryList"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Login History", "LoginHistoryList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Login History", "LoginHistoryList", null, "Date"],
              "arguments": { "iso": true },
              "template": ["data", null, "Activity", "Login History", "LoginHistoryList"]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Video Browsing History", "VideoList"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Video Browsing History", "VideoList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Video Browsing History", "VideoList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Like List", "ItemFavoriteList"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Like List", "ItemFavoriteList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Like List", "ItemFavoriteList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Following List", "Following"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Following List", "Following", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Following List", "Following", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Favorite Videos", "FavoriteVideoList"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Favorite Videos", "FavoriteVideoList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Favorite Videos", "FavoriteVideoList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Search History", "SearchList"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Search History", "SearchList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Search History", "SearchList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Comment", "Comments", "CommentsList"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Comment", "Comments", "CommentsList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Comment", "Comments", "CommentsList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Direct Messages", "Chat History", "ChatHistory", null],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Direct Messages", "Chat History", "ChatHistory", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Direct Messages", "Chat History", "ChatHistory", null, null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Favorite Sounds", "FavoriteSoundList"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Favorite Sounds", "FavoriteSoundList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Favorite Sounds", "FavoriteSoundList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "App Settings", "Block", "BlockList"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "App Settings", "Block", "BlockList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "App Settings", "Block", "BlockList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Video", "Videos", "VideoList"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Video", "Videos", "VideoList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Video", "Videos", "VideoList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Favorite Effects", "FavoriteEffectsList"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Favorite Effects", "FavoriteEffectsList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Favorite Effects", "FavoriteEffectsList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Favorite Hashtags", "FavoriteHashtagList"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Favorite Hashtags", "FavoriteHashtagList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Favorite Hashtags", "FavoriteHashtagList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Follower List", "FansList"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Follower List", "FansList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Follower List", "FansList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Share History", "ShareHistoryList"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Share History", "ShareHistoryList", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "Activity", "Share History", "ShareHistoryList", null, "Date"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        },
        {
          "path": ["data", null, "Activity", "Hashtag", "HashtagList"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "Activity", "Hashtag", "HashtagList", null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    }
  ],
  "fileStructure": ["user_data.json"],
  "optionalFileStructure": []
}
